import {Badge} from './badge';
import {Bar} from './bar';
import {Popup} from './popup';
import {Widget} from './widget';
import {RedeemField} from './redeem-field';
import CheckoutListener from './checkout-listener';
import {CustomerAccount} from './customer-account';
import {Customer} from './customer';

import {Tabs} from './tabs/tabs';
import {TabInfo} from './tabs/tab-info';
import {TabTerms} from './tabs/tab-terms';
import {TabStats} from './tabs/tab-stats';
import {TabHistory} from './tabs/tab-history';

/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @param {string} page
 * @constructor
 */
export let Application = function ($, config, library, page) {

  Spurit.global.selectors.add(config.getCartTotalSelector().selector, 'cart_subtotal');

  /**
   * @type {Customer}
   */
  let customerObj = new Customer($, config, library);
  if (config.getCustomer().id) {
    customerObj.takeVisit();
  }

  /**
   * @type {Tabs}
   */
  let tabs = new Tabs(
      $, config, library,
      new TabInfo($, config, library, customerObj),
      new TabStats($, config, library),
      new TabHistory($, config, library),
      new TabTerms($, config, library, customerObj),
  );

  /**
   * @type {Popup}
   */
  let popup = new Popup(
      $, config, library,
      customerObj,
      tabs
  );
  config.customization().onPopupReady(popup);

  if (config.isBadgeOn()) {
    let badge = new Badge(config, library, popup);
    if (config.customization().onBadgeReady(badge)) {
      badge.show();
    }
  }

  if (
      page === 'products'
      && config.isPurchasesActive()
      && isTargetProduct()
      && (config.getCustomer().id || config.customization().showProductPageWidgetAlways)
      && config.getInfoType() !== 'disabled'
  ) {
    new Widget($, config, library);
  }

  if (config.isRedeemOn() && page === 'cart') {
    new CheckoutListener(
        new RedeemField($, config, library),
        config,
        library
    );
  }

  if (config.isBarOn()) {
    let bar = new Bar($, config, library, popup);
    if (config.customization().onBarReady(bar)) {
      bar.show();
    }
  }

  if (config.isCustomerAccountOn(page)) {
    new CustomerAccount($, config, library, customerObj, tabs);
  }

  /**
   * Checks if current product purchase gives customer some points
   * @returns {boolean}
   */
  function isTargetProduct() {
    let products = config.getTargetProducts();
    if (products.length === 0) {
      return true;
    }

    let currentProductId = config.snippet().product.id;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product_id == currentProductId || products[i].product_id === 0) {
        return true;
      }
    }
    return false;
  }
};